/// <amd-module name="Dashboards/ConfigHost/ConfigHostTelemetry" />
import { DashboardsTelemetryConstants } from "Dashboards/Common/TelemetryConstants";
import { getErrorPropertiesForTelemetry } from "Dashboards/WidgetHost/Helpers/WidgetHostTelemetry";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";

export interface ConfigTelemetryInformation {
    widgetId: string | undefined;
    contributionId: string;
    configContributionId: string;
}

export interface ConfigErrorInformation extends ConfigTelemetryInformation {
    /** An error string or object for user facing presentation, in whatever form we get. */
    error: any;
}

/** Provides telemetry to track Config Host activity. */
export function publishConfigHostLoaded(pageContext: IVssPageContext, configInfo: ConfigTelemetryInformation): void {
    const telemetryService = pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
    const featureName = "ConfigLoadSuceeded"; // This is a new Platform only event, there was no telemetry for legacy Configs.
    telemetryService.publishEvent(DashboardsTelemetryConstants.Area, featureName, configInfo);
}

/** Provides telemetry describing problems reported to Config Host. */
export function publishConfigHostLoadFailed(pageContext: IVssPageContext, widgetErrorInfo: ConfigErrorInformation): void {
    const properties = {
        widgetId: widgetErrorInfo.widgetId,
        contributionId: widgetErrorInfo.contributionId,
        configContributionId: widgetErrorInfo.configContributionId,
        ...getErrorPropertiesForTelemetry(widgetErrorInfo.error)
    };

    const telemetryService = pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
    const featureName = "ConfigLoadFailed"; // This is a new Platform only event, there was no telemetry for legacy Configs.
    telemetryService.publishEvent(DashboardsTelemetryConstants.Area, featureName, properties);
}
